<div class="sms-container">
  <ul class="sms-list list-unstyled mb-0 p-0" id="smsTimeline">
    <!-- Right-aligned: sent/outbound messages (blue bubble) -->
    <li class="mb-3" *ngFor="let message of smsMessages; let i = index">
      <div *ngIf="isSentMessage(message) && message.messageType !== 'join_conversation' && message.callType !== 'join_conversation'" class="d-flex flex-column align-items-end"
           (mouseenter)="onSentMessageHover(message, i, true)"
           (mouseleave)="onSentMessageHover(message, i, false)">
        <div class="d-flex align-items-center justify-content-end gap-2 w-100">
          <div class="d-flex flex-column align-items-end">
            <span class="text-end small text-muted mb-1">{{ getMessageDisplayName(message) }}</span>
            <div class="sms-message-card sms-message-card--right card rounded-3 shadow-sm border-0 p-2 px-3 position-relative m-0">
              <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
                <span class="d-flex align-items-center gap-1">
                  <span class="fw-bold small">{{ isOutboundCall(message) ? 'Outbound Call' : 'SMS' }}</span>
                </span>
                <a *ngIf="hoveredMessageIndex === i" class="btn btn-link p-0 text-primary" title="Save as Template" (click)="openSaveTemplateModal(message); $event.stopPropagation()">
                  <i class="fa-solid fa-reply fs-7"></i>
                </a>
              </div>
              <div class="text-muted small message-body">{{ message.body }}</div>
              <!-- <div *ngIf="message.callType" class="message-media mt-2 small">
                <i class="fa-solid fa-phone text-success me-1"></i>
                {{ message.callType }}
              </div> -->
              <div *ngIf="message.mediaFilename" class="message-media mt-2 small text-muted">
                <i class="fa-solid fa-paperclip me-1"></i>
                {{ message.mediaFilename }}
              </div>
            </div>
            <small class="text-muted mt-1">{{ formatMessageDate(message.createdAt || '') }}</small>
          </div>
          <div class="sms-avatar sms-avatar--right my-auto rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 bg-soft-primary">
            <i [class]="isOutboundCall(message) ? 'fa-solid fa-phone fa-sm text-success' : 'fa-solid fa-comments fa-sm text-muted'"></i>
          </div>
        </div>
      </div>

      <!-- Left-aligned: inbound messages (grey card + purple avatar) -->
      <div *ngIf="!isSentMessage(message) && message.messageType !== 'join_conversation' && message.callType !== 'join_conversation'">
       
        <div class="d-flex align-items-start gap-2">
          <div class="flex-grow-1">
            <div class="d-flex align-items-center gap-2">
              <div class="sms-avatar rounded-circle d-flex my-auto align-items-center justify-content-center flex-shrink-0 bg-soft-primary">
                <i class="{{ message.callType ? 'fa-solid fa-phone text-success' : 'fa-solid fa-message text-muted' }} fa-sm"></i>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="small text-muted d-block mb-1">{{ getMessageDisplayName(message) }}</span>
                <div class="sms-message-card sms-message-card--left card rounded-3 shadow-sm border-0 p-2 px-3 bg-light m-0">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
                    <span class="d-flex align-items-start gap-1">
                      <div class="text-muted small message-body"><b class="me-1">SMS</b>{{ message.body }}</div>
                    </span>
                  </div>
                  <div *ngIf="message.callType" class="message-media mt-2 small">
                    {{ message.callType }}
                  </div>
                  <div *ngIf="message.mediaFilename" class="message-media mt-2 small text-muted">
                    <i class="fa-solid fa-paperclip me-1"></i>
                    {{ message.mediaFilename }}
                  </div>
                </div>
                <small class="text-muted d-block mt-1">{{ formatMessageDate(message.createdAt || '') }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Centered: join conversation separator -->
      <div *ngIf="message.messageType === 'join_conversation' || message.callType === 'join_conversation'"
           class="text-center py-2">
        <span class="small text-muted">
          {{ getMessageDisplayName(message) }} joined the conversation, {{ formatMessageDate(message.createdAt || '') }}
        </span>
      </div>
    </li>

    <li *ngIf="isLoading" class="text-center py-3">
      <i class="fa-duotone fa-spinner-third fa-spin fs-5"></i>
      <span class="ms-2">Loading messages...</span>
    </li>
    <li *ngIf="!isLoading && smsMessages.length === 0" class="text-center py-3 text-muted">
      No messages found
    </li>
  </ul>
</div>
